import React, { forwardRef } from 'react';

/**
 * FormInput - Componente de input básico con label y validación
 *
 * Props:
 * - label: Texto del label
 * - error: Mensaje de error (opcional)
 * - required: Indica si el campo es requerido (opcional)
 * - placeholder: Placeholder del input (opcional)
 * - type: Tipo de input (text, email, tel, date, number) (default: "text")
 * - className: Clases CSS adicionales (opcional)
 * - ...props: Cualquier otra prop de input HTML estándar
 */
const FormInput = forwardRef(({
  label,
  error,
  required = false,
  placeholder,
  type = 'text',
  className = '',
  ...props
}, ref) => {
  return (
    <div className={`mb-3 ${className}`}>
      <label className="form-label">
        {label}
        {required && <span className="text-danger">*</span>}
      </label>
      <input
        ref={ref}
        type={type}
        placeholder={placeholder}
        className={`form-control ${error ? 'is-invalid' : ''}`}
        {...props}
      />
      {error && (
        <div className="invalid-feedback d-block">{error}</div>
      )}
    </div>
  );
});

FormInput.displayName = 'FormInput';

export default FormInput;
